import '../../index.css';
var styles = {
  "calendar": "bp_calendar_module_calendar--1b662",
  "calendarGrid": "bp_calendar_module_calendarGrid--1b662",
  "calendarHeaderCell": "bp_calendar_module_calendarHeaderCell--1b662",
  "calendarHeader": "bp_calendar_module_calendarHeader--1b662",
  "calendarHeaderHeading": "bp_calendar_module_calendarHeaderHeading--1b662",
  "calendarHeaderButton": "bp_calendar_module_calendarHeaderButton--1b662",
  "calendarCell": "bp_calendar_module_calendarCell--1b662",
  "today": "bp_calendar_module_today--1b662"
};
export { styles as default };